import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";
import { TEST_CONFIGS } from "./testConfig";
import TestForm from "./TestForm";
import TestResultGroup from "./TestResultGroup";

export default function TestsSection({ studentId }) {
  const [tests, setTests] = useState(null);

  const load = useCallback(
    () => api.get(`/standardized-tests?student_id=${studentId}`).then((r) => setTests(r.data)).catch(() => setTests([])),
    [studentId]
  );
  useEffect(() => { load(); }, [load]);

  const remove = async (id) => { await api.delete(`/standardized-tests/${id}`); load(); };

  const groups = {};
  (tests || []).forEach((t) => { (groups[t.test_name] = groups[t.test_name] || []).push(t); });

  return (
    <div className="space-y-6">
      <TestForm studentId={studentId} onSaved={load} />

      {tests === null ? (
        <div className="flex justify-center py-10 text-slate-300"><Loader2 className="animate-spin" /></div>
      ) : tests.length === 0 ? (
        <p className="text-sm text-slate-400 text-center py-6">No tests recorded yet.</p>
      ) : (
        Object.entries(groups).map(([name, entries]) => (
          <TestResultGroup key={name} name={name} entries={entries} cfg={TEST_CONFIGS[name]} onDelete={remove} />
        ))
      )}
    </div>
  );
}
